export enum Sheet {
    Main = 'main',
    Login = 'login',
    Create = 'create',
    Checkout = 'checkout',
    PetInfo = 'petInfo',
    PetList = 'petList',
}
